import { parseIframeEmbedCode } from './embedCode';
import sheets from './sheets.png';
import type { EmbedProviderConfig } from './embed';

export const googleSheetsEmbedConfig: EmbedProviderConfig = {
  providerName: 'Google',
  titleKey: 'document.grid.embed.dialog_title_sheets',
  step1InstructionsKey: 'document.grid.embed.dialog_step_1_instructions_sheets',
  descriptionKey: 'document.grid.embed.dialog_description_sheets',
  inputLabelKey: 'document.grid.embed.dialog_input_label_sheets',
  docsUrl: 'https://support.google.com/docs/answer/183965',
  image: sheets,
  // Google's Sheets viewer needs its own origin to function - without allow-same-origin
  // it throws its own in-app "An error occurred" instead of rendering. Confirmed empirically.
  sandbox: 'allow-scripts allow-same-origin',
  parser: parseIframeEmbedCode,
};
